import * as React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";
import { Ban, Clock, Loader, XCircle } from "lucide-react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

interface StatusIconProps {
  currentStatus: string;
}

const StatusBadge: React.FC<{ icon: React.ReactNode; label: string }> = ({ icon, label }) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger>{icon}</TooltipTrigger>
      <TooltipContent>
        <p>{label}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export const StatusIcon: React.FC<StatusIconProps> = ({ currentStatus }) => {
  if (currentStatus === "queued" || currentStatus === "pending") {
    return <StatusBadge icon={<Clock className="size-3.5 text-neutral-400" />} label="In queue" />;
  }
  if (currentStatus === "processing") {
    return (
      <StatusBadge
        icon={<Loader className="size-3.5 animate-spin text-white" />}
        label="Processing..."
      />
    );
  }
  if (currentStatus === "processed" || currentStatus === "completed") {
    return (
      <StatusBadge
        icon={<IoMdCheckmarkCircleOutline className="size-3.5 text-white" />}
        label="Completed"
      />
    );
  }
  if (currentStatus === "failed") {
    return <StatusBadge icon={<XCircle className="size-3.5 text-white" />} label="Failed" />;
  }
  if (currentStatus === "cancelled") {
    return <StatusBadge icon={<Ban className="size-3.5 text-neutral-400" />} label="Cancelled" />;
  }
  return null;
};
